import React from "react"
import { Box } from "@mui/material"
import PropTypes from "prop-types"
import Documents from "src/v2/components/Documents/Documents"
import { useCompanyDocumentTable } from "../../hooks/use-company-document-table"

const OtherDocumentsTab = ({ cetip, isAdminUser, documentService, setIsLoading }) => {
    return (
        <Box sx={{ width: "100%", p: 3, boxSizing: "border-box" }}>
            <Documents
                cetip={cetip}
                isAdmin={isAdminUser}
                documentService={documentService}
                setIsLoading={setIsLoading}
                useTableHook={useCompanyDocumentTable}
            />
        </Box>
    )
}

OtherDocumentsTab.propTypes = {
    cetip: PropTypes.string,
    isAdminUser: PropTypes.bool.isRequired,
    documentService: PropTypes.any,
    setIsLoading: PropTypes.func,
}

export default OtherDocumentsTab